var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__j",
    cx: "-4.847%",
    cy: "-.239%",
    r: "401.337%",
    fx: "-4.847%",
    fy: "-.239%",
    gradientTransform: "matrix(.26722 0 0 1 -.036 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__m",
    cx: "-.122%",
    cy: ".104%",
    r: "136.314%",
    fx: "-.122%",
    fy: ".104%",
    gradientTransform: "matrix(1 0 0 .84752 0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3E2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3E2723",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "prefix__n",
    cx: "10.227%",
    cy: "-12.225%",
    r: "226.352%",
    fx: "10.227%",
    fy: "-12.225%",
    gradientTransform: "matrix(1 0 0 .49642 0 -.062)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#263238",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c",
    x1: "4.549%",
    x2: "36.95%",
    y1: "55.356%",
    y2: "42.739%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66%",
    stopColor: "#A52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__d",
    x1: "70.039%",
    x2: "41.91%",
    y1: "87.776%",
    y2: "66.337%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "33%",
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__g",
    x1: "41.002%",
    x2: "49.277%",
    y1: "-4.844%",
    y2: "45.391%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66%",
    stopColor: "#EA6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__e",
    d: "M0 36.364L19.039 36.364 27.875 27.527 27.875 20.909 12.125 20.909 0 0.109z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__h",
    d: "M1.136 0L9.011 13.636 0.175 29.091 21.136 29.091 21.136 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__k",
    d: "M0.22 0L0.22 9.168 9.173 24.545 17.045 10.909 37.045 10.909 37.045 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__a",
    cx: 20,
    cy: 20,
    r: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007BFF",
    d: "M0 0H64V64H0z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DB4437",
    fillRule: "nonzero",
    d: "M3.175 0L3.175 24.545 12.13 24.545 20 10.909 40 10.909 40 0z",
    transform: "translate(-.227)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    fillRule: "nonzero",
    d: "M3.175 0L3.175 24.545 12.13 24.545 20 10.909 40 10.909 40 0z",
    transform: "translate(-.227)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    fillOpacity: 0.15,
    fillRule: "nonzero",
    d: "M12.341 24.455L3.291 8.932 3.159 9.159 12.145 24.568z",
    transform: "translate(-.227)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F9D58",
    fillRule: "nonzero",
    d: "M0 36.364L19.039 36.364 27.875 27.527 27.875 20.909 12.125 20.909 0 0.109z",
    transform: "translate(-.227) translate(0 3.636)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    fillRule: "nonzero",
    d: "M0 40L19.039 40 27.875 31.164 27.875 24.545 12.125 24.545 0 3.745z",
    transform: "translate(-.227)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    fillOpacity: 0.15,
    fillRule: "nonzero",
    d: "M27.682 24.841L27.493 24.732 18.766 39.993 19.027 39.993 27.686 24.848z",
    transform: "translate(-.227)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.227) translate(0 3.636)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__e"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#prefix__f)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD40",
    d: "M1.136 0L9.011 13.636 0.175 29.091 21.136 29.091 21.136 0z",
    transform: "translate(18.864 7.273)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__g)",
    d: "M1.136 0L9.011 13.636 0.175 29.091 21.136 29.091 21.136 0z",
    transform: "translate(18.864 7.273)"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD40",
    fillRule: "nonzero",
    d: "M20 10.909L27.875 24.545 19.039 40 40 40 40 10.909z",
    transform: "translate(-.227)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__g)",
    fillRule: "nonzero",
    d: "M20 10.909L27.875 24.545 19.039 40 40 40 40 10.909z",
    transform: "translate(-.227)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.227) translate(18.864 10.91)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__h"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#prefix__i)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DB4437",
    d: "M0.22 0L0.22 24.545 9.175 24.545 17.045 10.909 37.045 10.909 37.045 0z",
    transform: "translate(-15.91 -10.91)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    d: "M0.22 0L0.22 24.545 9.175 24.545 17.045 10.909 37.045 10.909 37.045 0z",
    transform: "translate(-15.91 -10.91)"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.227) translate(2.955)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__j)",
    fillRule: "nonzero",
    d: "M17.045 10.909L17.045 15.67 34.864 10.909z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__k"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#prefix__l)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F9D58",
    d: "M0 36.364L19.039 36.364 27.875 27.527 27.875 20.909 12.125 20.909 0 0.109z",
    transform: "translate(-2.955 3.636)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    d: "M0 36.364L19.039 36.364 27.875 27.527 27.875 20.909 12.125 20.909 0 0.109z",
    transform: "translate(-2.955 3.636)"
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__m)",
    fillRule: "nonzero",
    d: "M3.175 9.193L16.186 22.202 12.127 24.545z",
    transform: "translate(-.227)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__n)",
    d: "M19.052 39.977L23.816 22.205 27.875 24.545z",
    transform: "translate(-.227)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.227)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 9.091,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 7.273,
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    fillOpacity: 0.2,
    d: "M20 10.682c-5.023 0-9.09 4.068-9.09 9.09V20c0-5.023 4.067-9.09 9.09-9.09h20v-.228H20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.1,
    d: "M27.864 24.545c-1.573 2.714-4.5 4.546-7.864 4.546s-6.295-1.832-7.864-4.546h-.009L0 3.745v.228l12.136 20.8c1.573 2.713 4.5 4.545 7.864 4.545s6.29-1.83 7.864-4.545h.011v-.228h-.014.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    d: "M20.227 10.91c-.038 0-.075.004-.113.006 4.968.061 8.977 4.102 8.977 9.084 0 4.982-4.01 9.023-8.977 9.084.038 0 .075.007.113.007 5.023 0 9.091-4.068 9.091-9.091s-4.068-9.09-9.09-9.09z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "M27.955 24.84c.772-1.335 1.22-2.88 1.22-4.535 0-.933-.143-1.86-.425-2.748.216.777.34 1.59.34 2.438 0 1.655-.447 3.2-1.22 4.537l.005.009-8.836 15.454h.263l8.653-15.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "M20 .227c11.007 0 19.936 8.893 20 19.887l.002-.114c0-11.045-8.954-20-20-20C8.957 0 0 8.955 0 20l.002.114C.064 9.12 8.993.227 20 .227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    fillOpacity: 0.15,
    d: "M20 39.773c11.007 0 19.936-8.893 20-19.887l.002.114c0 11.045-8.954 20-20 20C8.957 40 0 31.045 0 20l.002-.114c.062 10.994 8.991 19.887 20 19.887H20z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.dc1ab6a402a45798035b0f2d0e648fef.svg";
export { ForwardRef as ReactComponent };